import { render, staticRenderFns } from "./Scheme1.vue?vue&type=template&id=15cdb556&scoped=true"
import script from "./Scheme1.vue?vue&type=script&lang=js"
export * from "./Scheme1.vue?vue&type=script&lang=js"
import style0 from "./Scheme1.vue?vue&type=style&index=0&id=15cdb556&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cdb556",
  null
  
)

export default component.exports